<script>
import Banner from 'dashboard/components/ui/Banner.vue';
import { LocalStorage } from 'shared/helpers/localStorage';
import platformBannersAPI from 'dashboard/api/platformBanners';

const DISMISSED_KEY = 'dismissed_platform_banners';

const TYPE_SCHEME = {
  info: 'primary',
  warning: 'warning',
  error: 'alert',
};

export default {
  components: { Banner },
  data() {
    return { banners: [], dismissed: [] };
  },
  computed: {
    activeBanners() {
      return this.banners.filter(b => !this.dismissed.includes(b.id));
    },
  },
  mounted() {
    this.dismissed = LocalStorage.get(DISMISSED_KEY) || [];
    this.fetchBanners();
  },
  methods: {
    async fetchBanners() {
      try {
        const { data } = await platformBannersAPI.getActive();
        this.banners = data || [];
      } catch {
        // non-critical
      }
    },
    colorScheme(type) {
      return TYPE_SCHEME[type] || 'primary';
    },
    dismiss(id) {
      this.dismissed = [...this.dismissed, id];
      LocalStorage.set(DISMISSED_KEY, this.dismissed);
    },
  },
};
</script>

<template>
  <template v-for="banner in activeBanners" :key="banner.id">
    <Banner
      :banner-message="`${banner.title}: ${banner.message}`"
      :color-scheme="colorScheme(banner.banner_type)"
      has-close-button
      @close="dismiss(banner.id)"
    />
  </template>
</template>
